import { Box, Label, Paragraph, Text } from '@zillow/constellation-10';

interface Props {
  useLabel?: boolean;
  displayName?: string;
  nickname?: string;
  accountLast4?: string;
}

export const SelectedPaymentMethod = ({ displayName, nickname, accountLast4, useLabel }: Props) => (
  <Box>
    {useLabel ? <Label>Payment method</Label> : <Paragraph textStyle="body-bold">Payment method</Paragraph>}
    <Text>{`${nickname || displayName} ....${accountLast4}`}</Text>
  </Box>
);
